import axios from 'axios'
import {
    SimpleListEntityEnum,
    SimpleListParams,
    SimpleListResponse
} from '@/api/services/common/simple-list/common-simple-list.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class CommonSimpleListService {
    async getSimpleList(entity: SimpleListEntityEnum, params?: SimpleListParams): Promise<IResponseAgGrid<SimpleListResponse>> {
        const response = await axios.get<IResponseAgGrid<SimpleListResponse>>(`/simpleList/${entity}`, { params })
        return response.data
    }
}

export const commonSimpleListService = new CommonSimpleListService()
